import React, {useReducer} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import {
  featuresSetupShowMarkUpDownPopup,
} from "../featuresActions";
import FeaturesSetupMarkPopupHeader from "./FeaturesSetupMarkPopupHeader";
import MarkUpDownContext, {
  initialMarkUpDownValues,
  markUpDownContextReducer
} from "./FeaturesSetupMarkUpContext";
import FeaturesSetupMarkPopupApplyTo from "./FeaturesSetupMarkPopupApplyTo";
import FeaturesSetupMarkPopupSaveButton from "./FeaturesSetupMarkPopupSaveButton";
import FeaturesSetupMarkPopupList from "./FeaturesSetupMarkPopupList";

const FeaturesSetupMarkPopup = (props) => {

  const {featuresSetupShowMarkUpDownPopup, showMarkUpDownPopup} = props;
  const [markUpDownContextState, markUpDownContextDispatch] = useReducer(markUpDownContextReducer, initialMarkUpDownValues);

  if (!showMarkUpDownPopup) {
    return null
  }

  const closePopup = () => {
    featuresSetupShowMarkUpDownPopup(false);
  };

  return (
    <MarkUpDownContext.Provider value={{markUpDownContextState, markUpDownContextDispatch}}>
      <div className={"ui-popup ui-popup--mark"}>
        <button className="ui-popup-header__close ui-popup-header__close--small" onClick={closePopup}/>
        <div className="ui-popup__header ui-popup__header--center-small">
          <span className="generic-popup-title text-uppercase">
            <FormattedMessage id="features.setup.markUpDownPopup.title"/>
          </span>
        </div>
        <div className="ui-popup-body fs-mark">
          <FeaturesSetupMarkPopupHeader/>
          <FeaturesSetupMarkPopupList/>
          <FeaturesSetupMarkPopupApplyTo/>
        </div>
        <div className="ui-popup-footer">
          <button className="ui-button5 ui-button5--wide ui-button5--blue" onClick={closePopup}>
            <FormattedMessage id="messageBox.buttons.cancel"/>
          </button>
          <FeaturesSetupMarkPopupSaveButton/>
        </div>
      </div>
    </MarkUpDownContext.Provider>
  )
};

const mapStateToProps = (store) => {
  const {showMarkUpDownPopup} = store.featuresSetupState;

  return {
    showMarkUpDownPopup,
  };
};

const mapDispatchToProps = {
  featuresSetupShowMarkUpDownPopup,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupMarkPopup)
)
